"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.step.brief': 'Brief',
    'socialMediaPlan.step.preview': 'Vista previa IA',
    'socialMediaPlan.step.schedule': 'Planificar',
};
